// React
import { memo } from "react";

// Helpers
import { classNames } from "helpers";

import { ExtractionFlowProps } from "./types";

/**
 * Tijek obrade računa kao niz koraka. Razlika između načina čitanja nije u tome što se na kraju
 * dobije nego tko čita stranicu, pa se put datoteke prikazuje doslovno.
 */
const ExtractionFlow: React.FC<ExtractionFlowProps> = (props) => {
  const { steps } = props;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {steps.map((step, index) => (
        <div key={step} className="flex items-center gap-2">
          <span
            className={classNames(
              "px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap",
              index === steps.length - 1
                ? "bg-green-100 text-green-800"
                : "bg-slate-100 text-slate-700"
            )}
          >
            {step}
          </span>

          {index < steps.length - 1 && <span className="text-slate-400 text-xs">→</span>}
        </div>
      ))}
    </div>
  );
};

export default memo(ExtractionFlow);
